module.exports = __webpack_public_path__ + "img/image144.af149893.png";